import { Loading ,Message } from 'element-ui';
import router from '@/router/index'
import {Get} from "@/request/index.js"
import api from "@/request/api"
import store from '@/store/index'
import * as turf from 'turf';
import {booleanPointInPolygon} from '@turf/boolean-point-in-polygon';
import MapData from "./map/index"
import { mapMenu} from "./map/mapMenu"
import ZMYDataCollection from "./zmy-data-collection-3.0.0.min"
import { checkMobileValue,checkIdentityValue,validateIdentity,checkEmailValue,checkIntValue} from "@/utils/validate"
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
dayjs.extend(isBetween);

//是否在时间范围内 (时间格式类似2025-06-16T00:00:00）
export function  isTimeInRange(startTimeValue,endTimeValue){
    const startTime = dayjs(startTimeValue); // 开始时间
    const endTime = dayjs(endTimeValue);   // 结束时间
    const checkTime = dayjs()
    const flag = checkTime.isBetween(startTime, endTime, null, '[]');
    if(flag){
      return flag
    }else{
      //当前时间和结束时间比，如果是大于，那就是活动未结束，如果时间小于那就是未开始
      const compareTimeValue = compareTime(checkTime,endTime)
      const startTimeFormat =  dayjs(startTimeValue).format('YYYY-MM-DD HH:mm:ss');
      const endTimeFormat =  dayjs(endTimeValue).format('YYYY-MM-DD HH:mm:ss');
      return compareTimeValue==-1?`活动未开始，开始时间为${startTimeFormat}`:`活动已结束,结束时间为${endTimeFormat}`
    }
}

export function  compareTime(timeA, timeB) {
  const a = dayjs(timeA);
  const b = dayjs(timeB);
  if (a.isBefore(b)) return -1; // a 更早
  if (a.isAfter(b)) return 1;  // a 更晚
  return 0;                    // 相等
}

//活动/直播端外 H5 日活统计
export function openActivityH5(id,url){
  // 测试地址
  // ZMYDataCollection.init ({
  //   tenant_code: 'ff900bbef24b48748f5ab4685c4c92db',
  //   domain:"testrmapi.nfzmy.com",
  //   key: 'xY0rB2pH6uW9nG2sY5yE0jR3yP5mP0wM'
  // });
  //正式版的地址
  ZMYDataCollection.init ({
    tenant_code: 'prod-dgrb-b541b88a633dc950e75870',
    domain:"rmapi.nfzmy.com",
    key: '6gKcrFJNMUgdNtKe8QODo7swl5lyibei'
  });
  ZMYDataCollection.openActivityH5({
    activity_id: id,
    platform: '运营系统H5端',
    url:url
  });
}


//loading
export const loading = {
  loadingInstance: null, //loading实例
  // 加载loading
  open: function () {
    if (this.loadingInstance === null) {
      this.loadingInstance = Loading.service({
        target: '.main',
        text: '拼命加载中'
      });
    }
  },
  // 关闭loading
  close: function () {
    if (this.loadingInstance !== null) {
      this.loadingInstance.close();
    }
    this.loadingInstance = null;
  }
}
// 判断时间大于delayTime才显示loading
export const timeLoding = {
  requestCount:0,
  requestTimeIdList:[],
  delayTime:500,
  open(config){
    this.requestCount++;
    const timeId = setTimeout(() => {
      loading.open();
    },this.delayTime);
    this.requestTimeIdList.push({
      timeId: timeId,
      url: config.url
    });
  },
  close(url){
    this.requestCount--
    this.clearTimeoutByUrl(url, this.requestTimeIdList);
    if (this.requestCount <= 0) {
      loading.close();
    }
  },
  reset(){
    this.requestCount--
    this.resetTimeoutByUrl()
    if (this.requestCount <= 0) {
      loading.close();
    }
  },
  clearTimeoutByUrl(url,requestList){
    requestList.forEach((item,index)=>{
      if(item.url ===url){
        clearTimeout(item['timeId']);
        this.requestTimeIdzxList = requestList.splice(index,1)
      }
    })
  },
  resetTimeoutByUrl(){
    this.requestTimeIdList.forEach((timeItem,index) => {
      clearTimeout(this.requestTimeIdList[index]['timeId']);
    });
    this.requestTimeIdList = []
  },
}

//后端数据回显表单预览
export function initPreviewData(inputData, participateFieldList) {
  const inputArray = {
    "showName":"name",
    "showMobile":"mobile",
    "showIdentity":"identity",
    "showAddress":"address",
  }
  const formEnum = {
    "name": "姓名",
    "mobile": "电话",
    "identity": "身份证",
    "address": "地址"
  }
  const showInput =  inputData.map(item=>inputArray[item])
  let formItems = {}
  let formRules = {}
  if(showInput&&showInput.length>0){
    showInput.forEach(item => {
      if(item !== 'address'){
        formItems[item] = {
          class:"mb-20",
          type: "Input",
          labelWrap: true,
          value: "",
          label: formEnum[item],
        }
      }else{
        formItems[item] = {
          type: "Textarea",
          labelWrap: true,
          value: "",
          rows: 4,
          label: formEnum[item],
        }
      }
    })
  }
  const params = handleFormByType(participateFieldList,formItems,formRules)
  return  params
}

// 自定义信息表单处理
export function handleFormByType(participateFieldList,formItems= {},formRules= {}){
  let initRules = {
    name:{
        required: true,
        message: "姓名不能为空",
        trigger: "blur",
      },
      mobile:[
        {
          required: true,
          message: "电话不能为空",
          trigger: "blur",
        },
        {
          required: true,
          max: 11,
          min: 11,
          message: "请输入11位手机号",
          trigger: "blur",
        }
      ],
      identity:[
          {
          required: true,
          message: "身份证号不能为空",
          trigger: "blur",
        },
        { validator: validateIdentity, trigger: "blur" },
      ],
      address:[
        {
          required: true,
          message: "地址不能为空",
          trigger: "blur",
        }
      ]
  }
  let formType =['input',"select","upload","fileUpload"]
    let inputCheckData = {
      checkMobileValue,
      checkIdentityValue,
      checkEmailValue,
      checkIntValue
    }
  // 自定义信息表单处理
  if(participateFieldList&&participateFieldList.length>0){
    participateFieldList.forEach((item, index) => {
      formRules[formType[item.type-1] + index] = [{
        required: item.isRequired===2?true:false,
        message: item.label+"不能为空",
        trigger:item.type===1? "blur":"change",
      }]
      if(item.inputCheck&&item.inputCheck!=='none'){
        formRules[formType[item.type-1] + index].push({ 
          validator: inputCheckData[item.inputCheck], 
          trigger: item.type===1? "blur":"change"
        })
      }
      if (item.type === 1) {
        formItems['input' + index] = {
          type:item.rows===1?'Input': "Textarea",
          labelWrap: true,
          value: "",
          label: item.label,
          rows:item.rows,
          placeholder:item.placeholder
        }
      } else if (item.type === 2) {
        formItems['select' + index] = {
          type: item.isRadio ===1?"Radio":"Select",
          value: "",
          labelWrap: true,
          optionWrap:true,
          label: item.label,
          options: {
            data: JSON.parse(item.optionList),
            value: "value",
            label: "label",
          }
        }
      }else if(item.type === 4){
        formItems['fileUpload' + index] = {
          class:"mb-30",
          type: "FileUpload",
          acceptTypes:JSON.parse(item.fileTypeLimit),
          fileSize:item.fileSizeLimit,
          value: [],
          limit:item.fileNumLimit,
          labelWrap: true,
          label: item.label
        }
      } else {
        formItems['upload' + index] = {
          class:"mb-30",
          type: "Upload",
          value: "",
          labelWrap: true,
          fileSize:item.fileSizeLimit,
          limit:item.fileNumLimit,
          label: item.label,
          tips:`最多上传${item.fileNumLimit||1}个，大小不超过${item.fileSizeLimit??10}M的图片`
        }
      }
    })
  }
  formRules = {...initRules,...formRules}
  return {
    formItems,
    formRules
  }
}

// 线上登录根据参数跳转
  export const toPageByParams = (data,id,type)=>{
    store.commit("user/setToken", data.token);
    store.commit("user/setUserInfo", data.user);
    const routerMenu = ["question", "examine", "vote", "activity", "raffle", "competition", "customized"];
    const currentRouteKey = routerMenu[type - 1];
    const routeMapping = [
      {
        condition: (type, id) => type == 2 && ["1234"].includes(id),
        route: (id) => ({ name: 'examineTem1', params: { id } })
      },
      {
        condition: (type, id) => type == 2 && id == "1246",
        route: (id) => ({ name: 'employmentSurveyHome', params: { id } })
      },
      {
        condition: (type, id) => type == 4 && ["1470", "1472","1590","1591"].includes(id),
        route: (id) => ({ name: 'danceCompHome', params: { id } })
      },
      {
        condition: (type, id) => type == 4 && ["1627"].includes(id),
        route: (id) => ({ name: 'exposure', params: { id } })
      },
      {
        condition: (type, id) => type == 3 && ['1557','1556','1559'].includes(id),
        route: (id) => ({ name: 'containerVoting', params: { id } })
      },
      {
        condition: (type, id) => type == 3 && ['1492','1495','1504','1509','1510',"1613","1620"].includes(id),
        route: (id) => ({ name: 'danceVote', params: { id } })
      },
      {
        condition: (type, id) => type == 1 && ['1474','1479','1486',"1602"].includes(id),
        route: (id) => ({ name: 'interactiveH5', params: { id } })
      },
      {
        condition: (type, id) => type == 7 && ['100'].includes(id.toString()),
        route: (id) => ({ name: 'spreadCreativityHome', params: { id } }),
      },
      //税务局
      {
        condition: (type, id) => type == 6 && ['2026'].includes(id.toString()),
        route: (id) => ({ name: 'SWJCompetition'}),
      },
      //学习强国答题2025年版本
      {
        condition: (type, id) => type == 6 && ['1246'].includes(id.toString()),
        route: (id) => ({ name: 'newCompetition'}),
      },
      //学习强国答题2024年版本
      {
        condition: (type, id) => type == 6 && ['2024'].includes(id.toString()),
        route: (id) => ({ name: 'competition'}),
      },
      //消防问答
      {
        condition: (type, id) => type == 1 && ['1614','1644'].includes(id.toString()),
        route: (id) => ({ name: 'xiaoFangQuestion', params: { id } }),
      },
      //消防新春问答
      {
          condition: (type, id) => type == 1 && ["1645"].includes(id),
          route: (id) => ({ name: 'SpringFestivalQA', params: { id } })
      },
    ];
    const matchedRule = routeMapping.find(rule => rule.condition(type, id));
    if (matchedRule) {
      // 查找匹配的规则匹配定制的项目
      router.replace(matchedRule.route(id));
    }else {
      //跳转匹配运营系统后台创建活动
      router.replace({ name: currentRouteKey, params: { id } });
    }
  }

//本地登录模式根据参数跳转
export const toPageByTestParams = async (data,id,type,test)=>{
  await store.dispatch("user/login", data);
  const routerMenu = ["question", "examine", "vote", "activity", "raffle", "competition", "customized"];
  //查找匹配的规则匹配定制的项目
  const currentRouteKey = routerMenu[type - 1];
  const routeRules = [
    {
      condition: (type, id) => routerMenu[type - 1] === 'examine' && ["1234"].includes(id),
      route: (id) => ({ name: 'advertisingCompetition', params: { id } }),
    },
    {
      condition: (type, id) => routerMenu[type - 1] === 'examine' && id == "1246",
      route: (id) => ({ name: 'employmentSurveyHome', params: { id } }),
    },
    {
      condition: (type, id) => type == 4 && ["1470", "1472","1590","1591"].includes(id),
      route: (id) => ({ name: 'danceCompHome', params: { id } }),
    },
    //消防新春问答
    {
        condition: (type, id) => type == 1 && ["1645"].includes(id),
        route: (id) => ({ name: 'SpringFestivalQA', params: { id } })
    },
    {
        condition: (type, id) => type == 4 && ["1627"].includes(id),
        route: (id) => ({ name: 'exposure', params: { id } })
    },
    {
      condition: (type, id) => type == 3 && ['1492','1495','1498','1527','1504','1528','1377',"1613","1620"].includes(id),
      route: (id) => ({ name: 'danceVote', params: { id } }),
    },
    {
      condition: (type, id) => type == 3 && ['1572','1576','1577','1578'].includes(id),
      route: (id) => ({ name: 'containerVoting', params: { id } }),
    },
    {
      condition: (type, id) => type == 1 && ['1474','1498','1433','1506',"1602","1486"].includes(id),
      route: (id) => ({ name: 'interactiveH5', params: { id } }),
    },
    {
      condition: (type, id) => type == 7 && ['100'].includes(id.toString()),
      route: (id) => ({ name: 'spreadCreativityHome', params: { id } }),
    },
    //水务局2026问答
    {
      condition: (type, id) => type == 6 && ['2026'].includes(id.toString()),
      route: (id) => ({ name: 'SWJCompetition'}),
    },
    //学习强国答题2025年版本
    {
      condition: (type, id) => type == 6 && ['1246'].includes(id.toString()),
      route: (id) => ({ name: 'newCompetition'}),
    },
    //学习强国答题2024年版本
    {
      condition: (type, id) => type == 6 && ['2024'].includes(id.toString()),
      route: (id) => ({ name: 'competition'}),
    },
    //消防问答
    {
      condition: (type, id) => type == 1 && ['1614','1644'].includes(id.toString()),
      route: (id) => ({ name: 'xiaoFangQuestion', params: { id } }),
    }
  ];
  // 查找匹配的规则匹配定制的项目
  const matchedRule = routeRules.find(rule => rule.condition(type, id));
  if (matchedRule) {
    router.replace(matchedRule.route(id));
  } else {
    //跳转匹配运营系统后台创建活动
    router.replace({name: currentRouteKey,params: { id }});
  }
}

//ios刷新
export function iosRefresh(){
  let agent = navigator.userAgent
  let isIOS = !!agent.match(/\(i[^;]+;( U;)? CPU.+ Mac OS X/) // ios终端
  if(isIOS && !sessionStorage.getItem('isShareState')){
    sessionStorage.setItem('isShareState',true)
    // router.go(0)
    location.reload();
  }
}

//是否是微信环境下
export function isWeixin() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
      return true;
  } else {
      return false;
  }
};

//禁止分享
export function prohibitSharing(){
  if(isWeixin()){ // 微信环境下禁用分享
    document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
      WeixinJSBridge.call('hideOptionMenu'); // 通过下面这个API隐藏右上角按钮
    });
  }
}

//初始化JSSDK数据
export function initJSSDK(){
  return new Promise(async (resolve,reject)=>{
    const url = location.href.split('#')[0]
    fetch("https://duijie.timedg.com/project01/2019/weixin-jssdk-proxy-compat-old/api.php?r=weixin/jssdk/ConfigFromSN&snappid=3&url=" + url, {
      "method": "GET",
      "mode": "cors",
      "credentials": "omit"
    }).then((response) => {
        return response.json();
    }).then((data) => {
        if(data.code === 0){
          let config = data.rst
          // config.debug = true
          config.jsApiList = [
          "updateAppMessageShareData",//自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
          "updateTimelineShareData", //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
          "getLocation",//获取经纬度
          'onMenuShareTimeline', // 分享到朋友圈接口
          'onMenuShareAppMessage', //  分享到朋友接口
          'onMenuShareQQ', // 分享到QQ接口
          'onMenuShareQZone', // 分享到QQ空间
          'onMenuShareWeibo' // 分享到微博接口
          ],
          wx.config(config);
          wx.error((err) => {
            reject(err)
          });
          wx.ready(()=> {
            resolve()
          });
          return 
      }
      Message.error(data.err)
    });
  })
}

//初始化分享配置
export const initSharkConfig = async(type,id)=>{
  iosRefresh()
  await initJSSDK()
  const res = await Get(api.com.getSharKData + id)
  const shareData = {
    "imgUrl" :res.shareIcon?store.getters.baseUrl + res.shareIcon:"", 
    "link" : `${store.getters.baseUrl}H5/login/${id}/${type}`, 
    "title" :res.shareTitle.replace(/\s+/g, ''), 
    "desc" :res.shareDesc, 
    success : function() {
      console.log("只表示分享数据设置成功，而不是用户分享成功")
    },
    cancel : function() {
      console.log("只表示分享数据设置失败，而不是用户分享失败")
    }
  };
  wx.updateAppMessageShareData(shareData)//自定义“分享给朋友”及“分享到QQ”按钮的分享内容
  wx.updateTimelineShareData(shareData)//自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
  wx.onMenuShareTimeline(shareData);
  wx.onMenuShareAppMessage(shareData);
  wx.onMenuShareQQ(shareData);
  wx.onMenuShareQZone(shareData);
  wx.onMenuShareWeibo(shareData);
}

//获取地址位置
export const getLocation  = async(msg)=>{
  await initJSSDK()
  return new Promise((resolve,reject)=>{
    wx.getLocation({
      type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
      success: function (res) {
        resolve(res)
      },
      cancel : function(err) {
        resolve(false)
        console.log("err",err)
      }
    });
  })
}

//标题修改后在ios端不变,可以给页面加上一个内容为空的iframs 随后立即删除这个iframs,可以刷新title
export const changePageTitle = (title) => {
  var body = document.body;
  document.title = title.replace(/\s+/g, '');
  var iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.onload = function() {
      setTimeout(function() {
          iframe.onload = null;
          body.removeChild(iframe); 
      }, 0);
  };
  body.appendChild(iframe);
}

//是否本地用户(longitude(经度)latitude(纬度))
//方法内部的逻辑
//如果不允许授权得话,直接提示,需授权才能使用.直接返回false,
//父级流程,在最开始得时候初始化的时候,检测是不是在东莞坐标内,将结果存在data中.
//1.如果不授权返回值为null,就提示用户仅限东莞本地用户参与,可点击底部提交按钮再次授权
//2.如果不是东莞本地就返回值为false,就提示仅限东莞本地用户参与
//3.如果是东莞本地用户的话就存志为true,用户点击提交的时候,就可以开始执行表单提交
//执行的位置
//在初始化的时候的时候执行一遍,在提交按钮的时候执行一遍
//判断是否是区域内的用户
export const isLocalUser = async (areaArray)=>{
  const pointData = await getLocation()
  if(!pointData){
    Message.error("需要授权位置才可使用")
    return null
  }
  var pt = turf.point([pointData.longitude,pointData.latitude]);
  const newMapData = areaArray.map(item=>MapData[item]).flat()
  var poly = turf.multiPolygon(newMapData);
  const res = booleanPointInPolygon(pt, poly)
  const areaTips = areaArray.length===21?"广东": areaArray.map(item=>mapMenu[item]).join("、")
  if(!res){
    Message.error(`仅限${areaTips}本地用户使用`)
  }
  return res
}

//跟踪事件
export function trackEvent(category, action, label, value) {
  window._czc && window._czc.push(['_trackEvent', category, action, label, value])
}

//初始化分享配置(不调用接口,自己传参数的)
export const initShark = async(config={})=>{
  iosRefresh()
  await initJSSDK()
  const shareData = {
    "imgUrl" :"https://sp.timedg.com/H5/defaultSharkimg.jpg", 
    "link" : "https://sp.timedg.com/H5/login/1246/6",
    "title" :"学习赋能未来，强国你我同行",
    "desc" :"“全民学习 声动未来” 答题诵读活动",
    ...config,
    success : function() {
      console.log("只表示分享数据设置成功，而不是用户分享成功")
    },
    cancel : function() {
      console.log("只表示分享数据设置失败，而不是用户分享失败")
    }
  };
  wx.updateAppMessageShareData(shareData)//自定义“分享给朋友”及“分享到QQ”按钮的分享内容
  wx.updateTimelineShareData(shareData)//自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
  wx.onMenuShareTimeline(shareData);
  wx.onMenuShareAppMessage(shareData);
  wx.onMenuShareQQ(shareData);
  wx.onMenuShareQZone(shareData);
  wx.onMenuShareWeibo(shareData);
}


//初始化抽奖显示抽奖
export function initShowRaffle(activity) {
  store.commit("com/isHideRaffleMenu",activity.publishType==1?true:false)
  store.commit("com/initRaffleId",activity.lotteryId)
}
// 对象转formData的文件数据格式
export function getFormData(object) {
  const formData = new FormData();
  Object.keys(object).forEach(key => {
    const value = object[key];
    if (Array.isArray(value)) {
      value.forEach((subValue, i) => {
        formData.append(key + `[${i}]`, subValue)
      })
    } else {
      formData.append(key, object[key])
    }
  })
  return formData;
}

//给数字切换单位
export function cutNum(num,s,step,unit){
  s = s || 0;
  step = step || 10000;
  if(Math.abs(num) >= step){
      return cutNum(num/step,s+1,step,unit);
  }
  let relUnit = unit || ['','万','亿','万亿','兆','京','垓','杼'];
  return relUnit[s]!==''?num.toFixed(2)+relUnit[s]:num
}

export function replaceBr(text){
  return text.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>').replace(/\s/g, '&nbsp;')
}
//校验电话号码
export function verifyTel(tel){
  return /^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(Tel);
}

export function verifyEmile(emile){
  return /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/.test(emile);
}

//校验身份证
export function checkIdcard(value) {
  let message  = ""
  var sId = value;
  if (sId.length == 15) {
    if(!/^\d{14}(\d|x)$/i.test(sId)){
      message =  "你输入的身份证长度或格式错误";
      return false;
    } else  {
        sId=sId.substr(0,6)+'19'+sId.substr(6,9);
        sId+= getVCode(sId);
    }
  }
  function getVCode(CardNo17) {
    var Wi = new Array(7,9,10,5,8,4,2,1,6,3,7,9,10,5,8,4,2,1);
    var Ai = new Array('1','0','X','9','8','7','6','5','4','3','2');
    var cardNoSum = 0;
    for (var i=0; i<CardNo17.length; i++)cardNoSum+=CardNo17.charAt(i)*Wi[i];
    var seq = cardNoSum%11;
    return Ai[seq];
  }
  var aCity={11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",21:"辽宁",22:"吉林",23:"黑龙江",31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",42:"湖北",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏",61:"陕西",62:"甘肃",63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门",91:"国外"} ;

  var iSum=0 ;
  var info="" ;
  if(!/^\d{17}(\d|x)$/i.test(sId)){
    message =  "你输入的身份证长度或格式错误";
    return false;
  }
  sId=sId.replace(/x$/i,"a"); 
  if(aCity[parseInt(sId.substr(0,2))]==null){ 
    message =  "你的身份证地区非法";
    return false;
  }
  var sBirthday=sId.substr(6,4)+"-"+Number(sId.substr(10,2))+"-"+Number(sId.substr(12,2)); 
  var d=new Date(sBirthday.replace(/-/g,"/")) ;
  if(sBirthday!=(d.getFullYear()+"-"+ (d.getMonth()+1) + "-" + d.getDate())){
    message =  "身份证上的出生日期非法";
    return false; 
  }
  for(var i = 17;i>=0;i --) iSum += (Math.pow(2,i) % 11) * parseInt(sId.charAt(17 - i),11) ;
  if(iSum%11!=1){
    message =  "你输入的身份证号非法";
    return false; 
  }
  return true;
}

//获取保存的Cookie中的密码
export function getCookie() {
  let  echoAccount = {}
  if (document.cookie.length > 0) {
    var arr = document.cookie.split('; ')
    for (var i = 0; i < arr.length; i++) {
      var arr2 = arr[i].split('=') // 再次切割
      if (arr2[0] === 'userName') {
        echoAccount[arr2[0]] = arr2[1]
      } else if (arr2[0] === 'passWord') {
        echoAccount[arr2[0]] = arr2[1]
      }
    }
    return  echoAccount
  }
}

//密码和账号设置在cookike中
export function setCookie(name, pwd, exdays) {
  var exdate = new Date()
  exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays)
  window.document.cookie =
    'userName' + '=' + name + ';path=/;expires=' + exdate.toGMTString()
  window.document.cookie =
    'passWord' + '=' + pwd + ';path=/;expires=' + exdate.toGMTString()
}

export function clearCookie(name) {  
  setCookie(name, "", -1);  
}  

//本地图片转bin二进制文件
export function imageUrlToFile(imageUrl) {
  let image = new Image()
  image.setAttribute('crossOrigin', 'anonymous') // 解决跨域问题
  image.src = imageUrl // 如果是本地图片替换为 image.src = imageUrl
  return new Promise((resolve, reject) => {
    image.onload = () => {
      var canvas = document.createElement("canvas")
      canvas.width = image.width
      canvas.height = image.height
      var context = canvas.getContext('2d')
      context.drawImage(image, 0, 0, image.width, image.height)
      var quality = 0.8
      var dataURL = canvas.toDataURL("image/jpeg", quality) // 使用toDataUrl将图片转换成jpeg的格式,不要把图片压缩成png，因为压缩成png后base64的字符串可能比不转换前的长！
      const file = base64toFile(dataURL)
      resolve(file)
    }
  })
}

//将颜色值转为rgba
export function colorRgb(color,opacity){
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
  var sColor = color.toLowerCase();
  if(sColor && reg.test(sColor)){
    if(sColor.length === 4){
    var sColorNew = "#";
    for(var i=1; i<4; i+=1){
      sColorNew += sColor.slice(i,i+1).concat(sColor.slice(i,i+1));
    }
    sColor = sColorNew;
    }
    //处理六位的颜色值
    var sColorChange = [];
    for(var i=1; i<7; i+=2){
    sColorChange.push(parseInt("0x"+sColor.slice(i,i+2)));
    }
    if (opacity!== undefined){
    return "rgba(" + sColorChange.join(",") +','+opacity+ ")";
    }else{
    return "rgba(" + sColorChange.join(",") + ")";
    }
  }else{
    return sColor;
  }
}

export function base64toFile(dataurl, filename = 'file') {
  let arr = dataurl.split(',')
  let mime = arr[0].match(/:(.*?);/)[1]
  let suffix = mime.split('/')[1]
  let bstr = atob(arr[1])
  let n = bstr.length
  let u8arr = new Uint8Array(n)

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }

  let file = new File([u8arr], `${filename}.${suffix}`, {
    type: mime
  })
  return file
}

// tabel数据转excel
export function exportExcel(id) {
  //转换成excel时，使用原始的格式
  var xlsxParam = { raw: true };
  let fix = document.querySelector(".el-table__fixed");
  let wb;
  //判断有无fixed定位，如果有的话去掉，后面再加上，不然数据会重复
  if (fix) {
    wb = XLSX.utils.table_to_book(
      document.querySelector(id).removeChild(fix), xlsxParam);
    document.querySelector(id).appendChild(fix);
  } else {
    wb = XLSX.utils.table_to_book(document.querySelector(id), xlsxParam);
  }
  var wbout = XLSX.write(wb, {
    bookType: "xlsx",
    bookSST: true,
    type: "array",
  });
  try {
    FileSaver.saveAs(new Blob([wbout], { type: "application/octet-stream" }), "导出详情单.xlsx");
  } catch (e) {
    if (typeof console !== "undefined") console.log(e, wbout);
  }
  return wbout;
}



